import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Project } from '../project';
import { RuntimeService } from '../runtime.service';
import { ProjectService } from '../project.service';
import { PageService } from '../page.service';
import { DbRecordService } from '../db-record.service';
import { DbRecord } from '../db-record';
import { FilterService } from '../filter.service';
import { RatingService } from '../rating.service';
import { RTagGroupService } from '../r-tag-group.service';
import { SortService } from '../sort.service';

@Component({
  selector: 'app-project-db-records',
  templateUrl: './project-db-records.component.html',
  styleUrls: ['./project-db-records.component.css']
})
export class ProjectDbRecordsComponent implements OnInit {
  project: Project;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private rts: RuntimeService,
    private projects: ProjectService,
    private pgs: PageService,
    private dbrs: DbRecordService,
    private ss: SortService,
    private fs: FilterService,
    private ratings: RatingService,
    public rtgs: RTagGroupService,
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.project = this.projects.get(params['id']);
      if (!this.project) {
        this.projects.requestedProject = params['id'];
        return this.router.navigate(['projects']);
      }

      this.rts.currentProject = this.project;
      this.project.isInitialized = false;
      this.project.initProject();
    });
  }

  get isInitialized() {
    return this.project &&
      this.project.isInitialized &&
      this.rtgs.isInitialized;
  }

  get ratingTags() {
    return this.ratings.projectsAcceptedTags[this.project.shortcut];
  }

  get dbRecordsPage() {
    let ls = this.pgs.getPage(this.dbRecords);
    //  this.fts.checkRecords(ls)
    return ls;
  }


  get dbRecords(): DbRecord[] {
    let ls = this.fs.run(this.dbrs.getProjectDbRecordsList(this.project));
    let sortedLs = this.ss.run(ls);
    return sortedLs;
  }

  get sortFields() {
    let ls = [];
    this.project.criterionsList.forEach((c) =>
      ls.push({ tp: 'criterion', name: c.title, id: c.id }));
    return ls.concat([
      { tp: "dateDesc", name: "Date&#8615;" },
      { tp: "dateAsc", name: "Date&#8613;" },
      { tp: "source", name: "Source" }
    ]);
  }

  filterChange(txt) {
    txt = txt.trim();
    if (!txt) {
      return this.fs.searchFilter = null;
    }
    this.fs.searchFilter = new RegExp(txt, 'ig');
  }

  fromYearChange(txt) {
    const n = parseInt(txt.slice(0, 4), 10);
    this.fs.fromYearFilter = (n > 1800 && n < 2050) ? n : null;
  }

  toYearChange(txt) {
    const n = parseInt(txt.slice(0, 4), 10);
    this.fs.toYearFilter = (n > 1800 && n < 2050) ? n : null;
  }

  rcode(txt) {
    this.fs.ratingFilterCode = txt.trim();
  }
}




// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/project-db-records/project-db-records.component.ts